import { InvestmentGoalsInvestmentGoals } from '../../../../types';
export var list = [
    InvestmentGoalsInvestmentGoals.GROW,
    InvestmentGoalsInvestmentGoals.PRESERVE,
    InvestmentGoalsInvestmentGoals.COMPLETE_REVENUE,
];
